const ProgressBar = ({ current, total }) => {
  const progress = ((current + 1) / total) * 100;

  return (
    <div className="w-full mb-6 sm:mb-8">
      <div className="relative w-full h-3 bg-white/70 backdrop-blur-sm rounded-full overflow-hidden shadow-sm">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out animate-progress-glow"
          style={{
            width: `${progress}%`,
            background: 'linear-gradient(90deg, #2C5F8D 0%, #2D6A4F 100%)',
          }}
        />
      </div>

      <div className="flex items-center justify-between mt-2">
        <span className="text-xs sm:text-sm text-brand-neutral-600 font-medium">
          Question {current + 1} of {total}
        </span>
        <span className="text-xs sm:text-sm font-semibold text-brand-navy">
          {Math.round(progress)}%
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
